import React,{Component} from 'react';
import { ref } from '../config/constants'

class SelectBendedProduct extends Component{
    constructor(){
        super();
        
        this.data = this.data.bind(this);
        this.state ={
            productsList : {}
        }
    }

    componentWillMount() {

        let products = ref.child("Products").orderByChild("category").equalTo("Bended Accessories")
                products.on("value",function(snap){
                    
                    this.setState({
                        productsList : snap.val()
                    })

                }.bind(this))     
    }

    data(index){
       // console.log(this.product.value + index)
        let product = this.product.value
        let category = "Bended Accessories"
        if(product){
            this.props.setList(index,product,category)
        }else{
            alert("Please Select a Bended Accessories");
        }
    }
          
    render() {

         return (
            <tr>
                <td>
                    <div className="row nomarginLR">
                        <div className="tdSelect col-lg-7 col-md-5 col-sm-6 col-xs-6">
                            <select className="form-control"  ref={(input)=>{this.product=input}} >
                                <option></option>
                                { 
                                    this.state.productsList &&
                                    Object.keys(this.state.productsList).map(function (key){
                                        let list = this.state.productsList[key]

                                        if(list.status==="Active"){
                                            return <option value={key} key={key}> {list.name} </option>
                                        }else{
                                            return false;
                                        }
                                   }.bind(this))
                                }
                            </select>
                        </div>
                        <div className="tdBtn col-lg-5 col-md-3 col-sm-6 col-xs-6">
                            <button type="button" className="btn btn-sm btn-danger" onClick={()=>this.data(Date.now())}> <i className="fa fa-plus"></i></button>   
                        </div>
                    </div>
                </td>
            </tr>
        );
    }
}

export default  SelectBendedProduct;



// WEBPACK FOOTER //
// ./src/components/SelectBendedProduct.js